export default class Vip {
  constructor() {
    this.vipcardid = "";
    this.vipcardName = ""; //done
    this.limitedProductType = Vip.limitedProductTypeList()[0].id; //done
    this.dailyLimitCount = 0;
    this.discountRate = ""; //done
    this.isEnable = true; //done
    this.price = ""; //done
    this.soldCount = 0;
    this.totalLimitCount = 0;
    this.weeklyLimitCount = 0;
    this.shopids = []; //done
    this.vendorid = undefined; //done
    this.startDate = undefined; //done
    this.expireDate = undefined; //done
    this.remark = ""; //done
    this.dayCount = ""; //done
  }
  static limitedProductTypeList() {
    return [
      {
        id: 0,
        name: "不限制"
      },
      {
        id: 1,
        name: "洗衣"
      },
      {
        id: 2,
        name: "烘干"
      }
      // {
      //   id: 3,
      //   name: "洗涤剂"
      // }
    ];
  }
}
